import { useAsync } from "react-use";
import { ImageMedia } from "../types/VisualizerTypes";
import { useFrame } from "../components/Direct2D";

export function useImageMedia(media: ImageMedia | undefined)
{
    media = media ?? { type: "image" };

    const frame = useFrame(media.type == "image" ? media.frameConfig! : undefined)

    useAsync(async () => frame ? await frame.readyPromise : undefined, [frame?.readyPromise]);
    if (!frame?.url)
        return media;

    return { ...media, url: frame.url };
}
